require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-project-euler-problem-98-anagramic-squares.json") })
        }
      }, "path---coding-interview-prep-project-euler-problem-98-anagramic-squares");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-project-euler-problem-98-anagramic-squares!./.cache/json/coding-interview-prep-project-euler-problem-98-anagramic-squares.json
// module id = 1834
// module chunks = 231608221292675